import { onBeforeUnmount, onMounted, ref } from "vue";

const HOVER_DELAY = 100;

export function useDropdown() {

  const root = ref<HTMLElement | null>(null);
  const isExpanded = ref(false);
  let timeout: ReturnType<typeof setTimeout> | undefined;

  function clearTimer() {
    if (timeout) clearTimeout(timeout);
    timeout = undefined;
  }

  function setExpanded(value: boolean) {
    clearTimer();
    isExpanded.value = value;
  }

  function handleHover(isHovered: boolean) {
    clearTimer();
    timeout = setTimeout(() => {
      isExpanded.value = isHovered;
    }, HOVER_DELAY);
  }

  function open() {
    setExpanded(true);
  }

  function close() {
    setExpanded(false);
  }

  function handleOutsideClick(event: Event) {
    if (root.value && !root.value.contains(event.target as Node)) close();
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') close();
  }

  onMounted(() => {
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleKeydown);
  });

  onBeforeUnmount(() => {
    clearTimer();
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('keydown', handleKeydown);
  });

  return {
    root,
    isExpanded,
    handleHover,
    open,
    close,
  };
}
